<template>
  <Modal @close="closeModal">
    <template v-slot:title>{{ title }}</template>
    <template v-slot:body>
      <form class="my-2">
        <div class="form-group row my-1 mt-3">
          <ModalDropdown
            v-model="ticketCancelData.cancellationCause"
            :id="'status'"
            :label="'Cancel reason'"
            :default-option="'Select Reason'"
            :default-value="''"
            :dropdown="ticketCancelReason"
          >
            <template v-slot:error>
              <ModalError
                v-if="errorMessage && !ticketCancelData.cancellationCause && errors.ReasonToCancelIssue"
                :error="'Cancel reason field is required'"
              />
            </template>
          </ModalDropdown>
        </div>
        <div
          v-if="ticketCancelData.cancellationCause == 'অন্যান্য'"
          class="form-group row my-1"
        >
          <TextArea
            v-model="ticketCancelIssue"
            :placeholder="'Why are you cancelling Ticket?'"
            :id="'Cancel'"
            :type="'text'"
          >
            <template v-slot:error>
              <ModalError
                v-if="errorMessage && !ticketCancelIssue && errors.TicketCancelIssue"
                :error="'Ticket Cancel Issue is Required'"
              />
            </template>
          </TextArea>
        </div>
        <div class="form-group row my-1">
          <label class="col-sm-3 col-form-label"></label>
          <div class="col-sm-9">
            <button
              class="mt-3 py-2 mr-1 submit_button font_detail float-end"
              @click.prevent="ticketCancelConfirm"
            >
              Confirm
            </button>
          </div>
        </div>
      </form>
    </template>
  </Modal>
</template>

<script>
import useInputValidation from "@/modules/useInputValidations";
import { inject, ref, onBeforeMount, reactive } from "vue";
import store from "@/store";
import dropdownVariables from "@/modules/dropdownVariables";

export default {
  components: {},
  name: "ReserveTicketCancel",
  props: {
    ticketIdStore: {
      type: String,
    },
    ticketAmountPaid: {
      type: Number,
    },
    ticketAmountDues: {
      type: Number,
    },
    pagination: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const ticketCancelData = reactive({
      ticketId: "",
      cancellationCause: "",
      ticketType: "SEAT",
      refund: 0,
    });
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    let ticketCancelIssue = ref("");
    const title = ref("Cancellation Cause");
    let checked = ref([]);
    let allSelected = ref(false);
    const ticketCancelReason = dropdownVariables.ticketCancelReason;
    let errorMessage = ref(false);

    let { requiredValidation, errors } = useInputValidation();

    const getTicketsHistory = () => {
      showLoader();
      store
        .dispatch("getReservedTicketsHistory", props.pagination)
        .then(() => {
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
          if (error.status === 401) {
            getTicketsHistory();
          }
        });
    };

    const closeModal = () => {
      emit("update:modelValue", false);
      errorMessage.value = false;
    };

    const validate = () => {
      errorMessage.value = true;
      Object.keys(errors).forEach(function (key) {
        errors[key] = "";
      });
      requiredValidation(
        "ReasonToCancelIssue",
        ticketCancelData.cancellationCause.trim()
      );

      if (ticketCancelData.cancellationCause === "অন্যান্য") {
        requiredValidation("TicketCancelIssue", ticketCancelIssue.value.trim());
      }

      return !(
        Object.values(errors).length <= 0 ||
        !Object.values(errors).every((x) => x === null || x === "")
      );
    };

    const ticketCancelConfirm = () => {
      if (validate()) {
        showLoader();

        ticketCancelData.ticketId = props.ticketIdStore;
        ticketCancelData.refund = props.ticketAmountPaid;

        if (ticketCancelData.cancellationCause === "অন্যান্য") {
          requiredValidation("TicketCancelIssue", ticketCancelIssue.value.trim());
          ticketCancelData.cancellationCause = ticketCancelIssue.value;
        }
        store
          .dispatch("reserveTicketDelete", ticketCancelData)
          .then(() => {
            getTicketsHistory();
            emit("getAllTripsForTicketing");
            hideLoader();
            closeModal();
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              getTicketsHistory();
            }
          });
      }
    };

    onBeforeMount(() => {
      errorMessage.value = false
    });

    return {
      ticketCancelIssue,
      title,
      ticketCancelConfirm,
      closeModal,
      errors,
      errorMessage,
      checked,
      allSelected,
      ticketCancelReason,
      ticketCancelData,
    };
  },
};
</script>

<style scoped>
.custom-size-input {
  /* Double-sized Checkboxes */
  -ms-transform: scale(1.5); /* IE */
  -moz-transform: scale(1.5); /* FF */
  -webkit-transform: scale(1.5); /* Safari and Chrome */
  -o-transform: scale(1.5); /* Opera */
  padding: 1px;
  margin-right: 10px;
}
.custom-label {
  font-size: 16px;
  line-height: 0;
}
</style>
